export const SF_INPUT_ID = {
  BAR_CODE: '00NJz00000162mh',
  SALUTATION: '00NJz00000162me',
  FIRSTNAME: '00NJz00000162ml',
  LASTNAME: '00NJz00000162mm',
  STREET: '00N7Q00000DHjAA',
  ZIP: '00N7Q00000DHjAI',
  CITY: '00N7Q00000DHjAC',
  INBOUND: '00NJz00000162mb',
  BRAND: '00NJz0000015RyH',
  COUNTRY: '00N7Q00000DGvzC',
  PREFERED_LANG: '00NJz00000162md',
  ADDRESS_COUNTRY: '00NJz0000016MQH',
} as const;

type InputValue = {
  COUNTRY: string;
  PREFERED_LANG: string;
  ADDRESS_COUNTRY: string;
  RET_URL: string;
  SUBJECT_PREFIX: string;
};

export const SF_INPUT_VALUE: { [locale: string]: InputValue } = {
  de_DE: {
    COUNTRY: 'DE',
    PREFERED_LANG: 'DE',
    ADDRESS_COUNTRY: 'DE',
    RET_URL: 'https://oetker.de/hilfe',
    SUBJECT_PREFIX: 'oetker.de',
  },
  en_US: {
    COUNTRY: 'US',
    PREFERED_LANG: 'EN',
    ADDRESS_COUNTRY: 'US',
    RET_URL: 'https://oetker.us/contact-us',
    SUBJECT_PREFIX: 'oetker.us',
  },
  en_CA: {
    COUNTRY: 'CA',
    PREFERED_LANG: 'EN',
    ADDRESS_COUNTRY: 'CA',
    RET_URL: 'https://oetker.ca/support/contact-us',
    SUBJECT_PREFIX: 'oetker.ca',
  },
  fr_CA: {
    COUNTRY: 'CA',
    PREFERED_LANG: 'FR',
    ADDRESS_COUNTRY: 'CA',
    RET_URL: 'https://www.oetker.ca/fr_CA/support/nous-contacter',
    SUBJECT_PREFIX: 'oetker.ca',
  },
};
